import React from "react";
import RevolutionizeImg from "../../../images/location_new/fold7/custom-skyline.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Attain Unparalleled Growth with Our Software Development Company
              in UK
            </h2>
            <p>
              With continual innovation based on cutting-edge technologies, we
              build software products that simplify complex business processes.
              Saving much time and resources, you capitalize on the opportunity
              to further expand your business territory. As a reliable bespoke
              software development company we ensure a higher ROI considering
              our product. Further, our software solutions are always flexible
              to scalability based on the increasing requirements of a business.
              That’s how your options to grow your enterprise remain wide open
              with our customer software development UK.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="custom-software-development-company-uk"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
